import React from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';

import BaySpinner from '../../BaySpinner';

interface ShowDeleteThumbnailModal {
	show: boolean;
	rowData?: any;
}

interface DeleteThumbnailModalProps {
	t: (key: string) => string;
	showDeleteThumbnailModal: ShowDeleteThumbnailModal;
	setShowDeleteThumbnailModal: (value: ShowDeleteThumbnailModal) => void;
	onDelete: (fileName: string | undefined, rowData: any) => void;
	fileName?: string;
	isLoading?: boolean;
}

const DeleteThumbnailModal: React.FC<DeleteThumbnailModalProps> = ({
	t,
	showDeleteThumbnailModal,
	setShowDeleteThumbnailModal,
	onDelete,
	fileName,
	isLoading = false,
}) => {
	const handleDelete = () => {
		onDelete(fileName, showDeleteThumbnailModal.rowData);
		setShowDeleteThumbnailModal({ show: false });
	};

	return (
		<Modal
			centered
			className="delete-thumbnail-modal"
			show={showDeleteThumbnailModal.show}
			onHide={() => setShowDeleteThumbnailModal({ show: false })}
		>
			<Modal.Header closeButton>
				<Modal.Title>{t('deleteCustomThumbnail')}</Modal.Title>
			</Modal.Header>
			<Modal.Body>{t('deleteCustomThumbnailConfirm')}</Modal.Body>
			<Modal.Footer className="px-3 px-sm-5">
				<Row className="w-100 justify-between">
					<Col className="ps-0">
						<Button
							variant="outline-secondary"
							onClick={() => setShowDeleteThumbnailModal({ show: false })}
						>
							{t('cancel')}
						</Button>
					</Col>
					<Col className="pe-0" style={{ textAlign: 'right' }}>
						{isLoading ? (
							<Button variant="danger">
								<BaySpinner
									textColor="text-white"
									title="Deleting..."
									variant="light"
								/>
							</Button>
						) : (
							<Button variant="danger" onClick={handleDelete}>
								{t('delete')}
							</Button>
						)}
					</Col>
				</Row>
			</Modal.Footer>
		</Modal>
	);
};

export default DeleteThumbnailModal;
